import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names, letting a caller's utility win over a component's
 * default for the same property.
 *
 * Plain concatenation does not: `"px-4" + "px-2"` leaves both in the
 * class list and the winner is whichever CSS rule came last in the
 * stylesheet, which is not something a call site can reason about.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
